import { ReactNode } from 'react';

type VariantProps = {
    className: string;
    children: ReactNode;
}

export const variants = {
    'heading-1': ({ children, className }: VariantProps) => <h1 className={className}>{children}</h1>,
    'paragraph': ({ children, className }: VariantProps) => <p className={className}>{children}</p>,
    'text': ({ children, className }: VariantProps) => <span className={className}>{children}</span>,
    'subtitle': ({ children, className }: VariantProps) => <small className={className}>{children}</small>,
};

export type Variant = keyof typeof variants;
